import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { checkSession, login as apiLogin, clearToken } from '../lib/api';

const AuthContext = createContext({
  isOwner: false,
  checking: true,
  login: async () => {},
  logout: () => {},
});

export const AuthProvider = ({ children }) => {
  const [isOwner, setIsOwner] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      const valid = await checkSession();
      if (!valid) clearToken();
      setIsOwner(valid);
      setChecking(false);
    })();
  }, []);

  const login = useCallback(async (password) => {
    await apiLogin(password);
    setIsOwner(true);
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setIsOwner(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isOwner, checking, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
